<template>
  <div class="loginForm">
    <v-card class="mx-auto" max-width="95%">
      <v-list-item-title class="headline mb-1"
        >Create Researcher Account
      </v-list-item-title>
      <v-divider></v-divider>
      <div>
        <v-form ref="form" align="center" v-model="valid">
          <v-text-field
            v-model="firstName"
            label="*First Name"
            :rules="firstNameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            label="*Last Name"
            :rules="lastNameRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="organization"
            label="*Organization"
            :rules="organizationRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="phoneNumber"
            label="Phone Number"
            :rules="phoneRules"
          ></v-text-field>
          <v-text-field
            v-model="email"
            label="*Email"
            :rules="emailRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="confirmEmail"
            label="*Confirm Email"
            :rules="confirmEmailRules"
            required
            :error-messages="emailMatchError()"
          ></v-text-field>
					<div class="recaptchaText">
						This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
					</div>
          <v-btn @click="canceledForm">Cancel</v-btn>
          <v-btn class="btn-default" text :disabled="!valid" @click="recaptcha">
            Submit
          </v-btn>
        </v-form>
      </div>
    </v-card>
    <foe-dialog v-model="dialog" :dialogW="dialog" max-width="420" top="300" transition="dialog-bottom-transition">
      <v-card max-width="400" >
        <v-card-title class="text-h5">
          ASA24 Researcher Agreement
        </v-card-title>
        <v-card-text style="overflow-y: auto; height: 400px; text-align: left">
          <div
            class="termsOfUseText"
            style="
              font-family: Calibri, Arial, Helvetica, sans-serif;
              font-size: 16px;
              text-align: left;
            "
          >
            <p style="text-align: center"><b>ASA24® Researcher Agreement</b></p>

            <p style="text-align: center">
              Electronic Certification (E-Certification) and Agreement For use
              of the Automated Self-Administered 24-hour Dietary Assessment Tool

              <b>("ASA24®")</b> and Transfer of Data
            </p>

            <p style="text-align: center; margin-bottom: -8px">
              Epidemiology and Genomics Research Program

              <br />

              Division of Cancer Control and Population Sciences

              <br />

              National Cancer Institute
            </p>
            <p
              style="
                text-decoration: underline;
                margin-top: 30px;
                text-align: left;
              "
            >
              DEFINITIONS:
            </p>

            <p style="margin-top: 20px; margin-bottom: 30px">
              NCI: Epidemiology and Genomics Research Program, Division of
              Cancer Control and Population Sciences, National Cancer Institute,
              National Institutes of Health (NIH), an agency of the United
              States Public Health Service (PHS) within the Department of Health
              and Human Services (DHHS)
            </p>

            <p style="text-decoration: underline; margin-top: 30px">
              RESEARCHER:
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              An organization, as represented by its academic, clinical, or
              private researchers conducting observational studies with human
              subjects. “RESEARCHER” may also include academic, clinical, or
              private individuals who conduct observational studies with human
              subjects under their own legal authority independent of an
              employer or parent organization for research, treatment or
              education purposes.
            </p>

            <p style="text-decoration: underline; margin-top: 30px">DATA:</p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              De-identified human dietary intake data collected by the NCI under
              auspices of NCI’s Automated Self-Administered 24-hour Dietary
              Assessment Tool (“ASA24”) and resulting calculations. “DATA” does
              not mean the ASA24 database, associated databases, or software
              used to create and run the ASA24 system.
            </p>

            <p style="text-decoration: underline">RECITALS:</p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              WHEREAS, the NCI has constructed a research tool in the form of an
              ASA24 computerized interview and database, and this database is
              intended to assist RESEARCHER and human subjects under the
              RESEARCHER’s supervision with management of DATA associated with
              those human subjects; and
            </p>

            <p style="margin-top: 20px; margin-bottom: 30px">
              WHEREAS, the RESEARCHER intends to direct human subjects under
              RESEARCHER’s supervision to submit dietary intake data to the
              ASA24 database; and,
            </p>

            <p style="margin-top: 40px; margin-bottom: 25px">
              WHEREAS, the NCI wishes the RESEARCHER to have access to DATA
              describing the human subjects under RESEARCHER’s supervision;
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              In consideration of the above, the RESEARCHER and NCI agree to the
              following:
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              1. The RESEARCHER will be responsible for directing human subjects
              under its supervision to submit DATA to the NCI. NCI will store
              the DATA in NCI’s ASA24 database. NCI will maintain the DATA in
              the absence of identifying information; however, NCI will have the
              right to assign a unique alphanumeric username tag to records
              describing individual human subjects. NCI shall ensure that the
              nature of such tag will prevent NCI from determining human subject
              identities. The RESEARCHER, but not NCI, will retain the crosswalk
              for mapping the tag to identify individual human subjects under
              RESEARCHER’s supervision. NCI will not have access to the
              crosswalk. NCI will not communicate with any human subjects
              providing DATA.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              2. DATA submitted to the NCI is the property of the NCI for
              distribution purposes and shall be made available as a service to
              research, academic and clinical communities.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              3. The DATA will be used only for research, clinical and academic
              purposes. THIS DATA WILL NOT BE USED BY NCI TO TREAT OR DIAGNOSE
              HUMAN SUBJECTS. In the event that:
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px; margin-left: 20px">
              (a) a party to this agreement is able to deduce the identity of an
              individual human subject whose information is a component of the
              DATA;
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px; margin-left: 30px">
              And,
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px; margin-left: 20px">
              (b) the human subject is <u><i>not being supervised by</i></u> or
              <u><i>under care of</i></u> the party,
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              then that party agrees it will not attempt to identify or contact
              such human subject and, furthermore, will notify the other party
              of its ability to make such identification.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              4. Neither NCI nor RESEARCHER will use the DATA unless it has
              obtained all appropriate clearances to use the DATA, including but
              not limited to clearance by an Institutional Review Board or
              equivalent governing body. The use and handling of the DATA by
              either party will be performed in compliance with all applicable
              statutes and regulations.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              5. The RESEARCHER may redistribute DATA to third parties for
              research, clinical, and academic purposes under conditions of use
              no less restrictive than those of this Agreement.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              6. The RESEARCHER agrees to acknowledge the source of the DATA in
              any publications reporting use of it.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              7. NCI shall have the right to conduct quality assurance measures
              of the DATA including, but not limited to, reviews of system
              logic, evaluation of missing DATA, and summary statistics based on
              DATA across the entire system. No evaluation of, or publication
              based on, a single registered study will be performed by NCI. The
              NCI represents that its role in managing the DATA shall be
              primarily archival, and that the NCI will not conduct
              investigative activities with the DATA.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              8. Any DATA delivered pursuant to this Agreement is understood to
              be experimental in nature. THE NCI MAKES NO REPRESENTATIONS AND
              EXTENDS NO WARRANTIES OF ANY KIND, EITHER EXPRESSED OR IMPLIED.
              THERE ARE NO EXPRESS OR IMPLIED WARRANTIES OF MERCHANTABILITY OR
              FITNESS FOR A PARTICULAR PURPOSE, OR THAT THE USE OF THE DATA WILL
              NOT INFRINGE ANY PATENT, COPYRIGHT, TRADEMARK, OR OTHER
              PROPRIETARY RIGHTS.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              9. No indemnification for any loss, claim, damage, or liability is
              intended or provided by any party under this agreement. Each party
              shall be liable for any loss, claim damage, or liability that said
              party incurs as a result of said party's activities under this
              agreement, except that the NCI, as an agency of the United States,
              assumes liability only to the extent as provided under the Federal
              Tort Claims Act (28 U.S.C. Chapter 171). If the RESEARCHER is a
              component of or an agency of a State government then RESEARCHER
              assumes liability only to the extent authorized under the laws of
              the State or Commonwealth.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              10. RESEARCHER agrees not to claim, infer, or imply endorsement of
              the RESEARCHER by the NCI and by the Government of the United
              States of America.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              11. Upon request by the NCI, the RESEARCHER will perform any of
              the following as directed by the NCI: (a) immediately cease use of
              the DATA; (b) dispose of DATA provided by the NCI that is in the
              RESEARCHER's possession.
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              Any false or misleading statements made, presented, or submitted
              to the Government, including any relevant omissions, under this
              Agreement are subject to all applicable civil and criminal
              statutes including Federal statutes 31 U.S.C. §§ 3801-3812 (civil
              liability) and 18 U.S.C. § 1001 (criminal liability including
              fine(s) and/or imprisonment).
            </p>

            <p style="margin-top: 20px; margin-bottom: 25px">
              By accepting the terms of this agreement, the RESEARCHER certifies
              that the information submitted by the RESEARCHER is true, complete
              and accurate to the best of RESEARCHER's knowledge. The person
              accepting the terms of this agreement for the RESEARCHER has the
              requisite power and authority to accept the terms of this
              Agreement.
            </p>

            <p style=""><b>ASA24®</b> is a registered trademark of DHHS.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            class="btn-default"
            text
            @click="downloadResearcherAgreement()"
            download
          >
            Download
          </v-btn>
          <v-btn class="btn-default" text @click="dialog = false">
            Decline
          </v-btn>

          <v-btn class="btn-default" text @click="registerUser" :loading="isSubmitting"> Accept </v-btn>
        </v-card-actions>
      </v-card>
    </foe-dialog>
  </div>
</template>

<script>
import { utilityService } from '@/services/utilityService.js';
import { researcherApiService } from '@/services/researcherApiService.js';
import { authTokenService } from '@/services/authTokenService.js';
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
Vue.use(VueReCaptcha, { siteKey: '6LeQqOAbAAAAAE-KFRgshqRrFYCtVEqm_lF7LLq1' });

export default {
	name: 'RegistrationForm',
	data: () => ({
		env: null,
		valid: true,
		loginUrl: null,
		firstName: null,
		lastName: null,
		organization: null,
		phoneNumber: null,
		email: null,
		confirmEmail: null,
		solution: null,
		dialog: false,
		firstNameRules: [(v) => !!v || 'First Name is required'],
		lastNameRules: [(v) => !!v || 'Last Name is required'],
		organizationRules: [(v) => !!v || 'Organiation is required'],
		phoneRules: [
			v => {
				const phonePattern = /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/
				const emptyPattern = /^$/
				return phonePattern.test(v) || emptyPattern.test(v) || !v || 'Phone number must be proper format XXX-XXX-XXXX';
			}],
		emailRules: [
			(v) => !!v || 'E-mail is required',
			(v) => /.+@.+/.test(v) || 'E-mail must be valid email format'
		],
		confirmEmailRules: [
			(v) => !!v || 'Confirm E-mail is required',
			(v) => /.+@.+/.test(v) || 'E-mail must be valid email format'
		],
		loading: false,
		myToken: null,
		isSubmitting: false
	}),
	props: {},
	mounted () {
		this.env = utilityService.getEnv();
		authTokenService.clearSession();
	},
	methods: {
		registerUser () {
			this.isSubmitting = true;

			var ApiUserData = {
				email: this.email,
				firstName: this.firstName,
				lastName: this.lastName,
				organization: this.organization,
				phoneNumber: this.phoneNumber,
				captchaToken: this.myToken
			};
			// console.log('ApiUserData: ', ApiUserData)
			const me = this;
			researcherApiService.register(ApiUserData).then(function (response) {
				me.isSubmitting = false;
				// if (authTokenService.getToken() != null) {
				me.$store.dispatch('changeUpdateStatus', { status: 'register-user-success' });
				me.$router.push('/login');
				// }
			}).catch(function (e) {
				me.isSubmitting = false;
				let errorMessage = 'error';
				if (e.response.data.messages) {
					errorMessage = e.response.data.messages[0]
				}
				me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'register-user-fail', message: errorMessage });
			});
		},
		emailMatchError () {
			return this.email === this.confirmEmail ? '' : 'Email must match';
		},
		async recaptcha () {
			// (optional) Wait until recaptcha has been loaded.
			await this.$recaptchaLoaded();
			// Execute reCAPTCHA with action "login".
			const token = await this.$recaptcha('login');
			this.myToken = token;
			this.dialog = true;
		},
		canceledForm () {
			const me = this;
			me.$router.push('/login');
		},
		downloadResearcherAgreement () {
			window.open('ASA24ResearcherSiteAgreement.pdf', '_blank');
		}
	}
};
</script>

<style>
.v-text-field,
.v-btn {
  margin: 10px;
}
.recaptchaText {
	font-size:12px;
}
</style>
